/*
 * @Author: your name
 * @Date: 2020-08-21 18:15:16
 * @LastEditTime: 2020-09-16 22:04:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\server\material.js
 */

import http from "../utils/http";
export default{
    stPage:function(data,fun){
        http.get("/appuser/page",data,fun)
    },
	 //职位字典
	dictionarydetail:function(data,fun){
	    http.get("/inner/st-dictionary-detail/get/POSITION",data,fun)
	}, 
	//部门查询
	salemandepartment(data,fun) {
	    http.post("/st-saleman-department/list",data,fun)
	},
    // 审核通过
    auditCheck:function(data,fun){
        http.put("/appuser/approve",data,fun)
    },
    // 审核不通过
    auditUnCheck:function(data,fun){
        http.put("/appuser/refuse",data,fun)
    },
    getRecommend(data,fun) {
        http.post("/appuser/recommend-page",data,fun)
    },
    freezeUser(data,fun) {
        http.post("/appuser/frozenAppUser",data,fun)
    },
    upFile(data,fun) {
        http.post("/file/upload",data,fun)
    },
    saveShuiDaShiImg(data,fun) {
        http.post("/appuser/saveShuiDaShiImg",data,fun)
    },
    shuiDShiSignUp(data,fun) {
        http.post("/appuser/submitSign",data,fun)
    },
    updateMiniUser(data,fun) {
        http.put("/appuser/updateMiniUser",data,fun)
    },
	payUploadIdcard(data,fun) {
        http.post("/appuser/pay-upload-idcard",data,fun)
    },
	//员工归属树状
	querySaleman(fun) {
	    http.post("/st-saleman-department/querySaleman",fun)
	},
	//员工列表
	list(data,fun) {
	    http.post("/st-saleman/list",data,fun)
	},
	//新增员工
	salemanadd(data,fun) {
			http.post("/st-saleman/add",data,fun)
		},
		//删除员工
	salemandelate(id,fun) {
		 http.post("/st-saleman/delete"+"/"+ id,fun)
	},
	//修改员工信息
	salemanupdate(data,fun) {
		 http.post("/st-saleman/update",data,fun)
	},
	//查询转化记录
	ownerconversion(data,fun) {
		 http.post("/owner-conversion/query",data,fun)
	},
	//后台解绑信息
	unbind(data,fun) {
		 http.post("/appuser/unbind-saleman",data,fun)
	},

	}